<template>
  <div class="m-card" style="align-items: center;gap:5px">
    <div><img :src="item.img" alt="img" height="100"/></div>
    <div>{{ item.name }}</div>
    <div>{{ item.status ? "🟢 Active" : "🔴 Insctive" }}</div>
    <div>Device ID : {{ item.mac }}</div>
    <div>First Check in : {{ item.firstdate }}</div>
    <div style="width: 100%">
      <b-progress
        :value="item.manhour"
        :max="max"
        show-value
        variant="success"
        class="mb-3"
      ></b-progress>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  data() {
    return {
      max: 8,
    };
  },
};
</script>

<style>
</style>